


















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Penunjang extends Vue {
  @Prop() setPenunjang: string;
  @Prop() rows: number;
  penunjang = "";
  label = "";
  validasi = [v => !!v || "*Kolom penunjang harus diisi"];

  @Watch("penunjang")
  changePenunjang(v) {
    if (v == "") {
      this.label = "";
    } else {
      this.label = "Penunjang";
    }
    this.$emit("penunjang", v);
  }
  @Watch("setPenunjang")
  changeSetPenunjang(v) {
    this.penunjang = v;
  }
}
